import { RouteConfig } from 'vue-router'

const Index = () => import('./summer-vacation-stu/index.vue')

export const indexRoute: RouteConfig = {
  path: '/summer-vacation-2025-stu-home',
  name: 'summer_vacation_2025_stu_home',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '暑假体育作业安排',
    ignoreLogin: true,
  },
}

export default [indexRoute]
